import Vue from 'vue';
import axios from 'axios';
// import VueAxios from 'vue-axios';
import './plugins/axios.js';
import './plugins/fontawesome.js';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'jquery';
import CKEditor from '@ckeditor/ckeditor5-vue';
// import { createPopper } from '@popperjs/core';
import moment from 'moment';
import VueMoment from 'vue-moment';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import '@/style/index.scss';
import VueMeta from 'vue-meta';
import VueCurrencyFilter from "vue-currency-filter";
import "@/filter/public.js";
import DatePicker from 'vue2-datepicker';

// options 可以作額外設定
Vue.use(VueMeta, {});
Vue.config.productionTip = false;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.get["Content-Type"] = "application/json";
// Vue.use( ax _);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CKEditor);
Vue.use(VueMoment);
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ",",
  fractionCount: 0,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});

Vue.component("Datepicker", DatePicker);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
